<template>
  <div>
    <div class="show_mobile card">
      <b-row class="text-center p-1" align-h="center">
        <div
          v-for="p in projects.filter(
            r => r.name == 'Daily Productivity Report'
          )"
          :key="p.name"
        >
          <b-row class="pb-1" align-v="center">
            <b-col>
              <b-button variant="success" @click="$emit('loadProject', p.name)">
                {{ p.name }}
              </b-button>
            </b-col>
          </b-row>
        </div>
      </b-row>
    </div>
  </div>
</template>

<style scoped>
.card {
  overflow-y: auto;
}
.scroll-Container::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
}
.scroll-Container::-webkit-scrollbar {
  width: 6px;
  background-color: #f5f5f5;
}
.scroll-Container::-webkit-scrollbar-thumb {
  background-color: #797777;
}
</style>

<script>
export default {
  name: 'MMP_SubNav',
  props: [
    'btnClass',
    'layersListMaxHeight',
    'projects'
  ],
  mounted() {
    this.$emit('onResize')
  }
}
</script>
